var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","title":_vm.title},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-magnify")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }